import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';

/* import function from store folder */
import { resetModel } from '../../store/components/modelSlice';

const ForgetModel = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { detail, currentKey } = useSelector(state => state.detail);
        
    const cancelHandler = () => dispatch(resetModel());

    const confirmText = {
        pickup: '取車完成',
        approach: '進廠完成',
        leave: '離廠完成',
        return: '還車完成'
    };

    const confirmation = () => {
        cancelHandler();
        navigate('/driver/list');
    };

    return (
        <Modal show={ true } onHide={ cancelHandler } centered>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
                <div className="message-container">
                    <h2>{ confirmText[currentKey] }</h2>
                    <p>{ `車牌號碼：${detail.carNo}` }</p>
                </div>
                <div className="button-container">
                    <Button type="button" data-shadow onClick={ confirmation }>確定</Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default ForgetModel;